import React from 'react'
import PropTypes from 'prop-types'

import { Button } from 'react-wot-bootstrap'

import { ANNOUNCEMENT_MODE } from '../../constants'

import {
    ANNOUNCEMENT_CONFIRMATION_TITLE_ARCHIVE,
    ANNOUNCEMENT_CONFIRMATION_DESCRIPTION_ARCHIVE,
    ANNOUNCEMENT_CONFIRMATION_TITLE_DELETE,
    ANNOUNCEMENT_CONFIRMATION_DESCRIPTION_DELETE,
    ANNOUNCEMENT_CONFIRMATION_BUTTON_APPLY_ARCHIVE,
    ANNOUNCEMENT_CONFIRMATION_BUTTON_APPLY_DELETE,
    ANNOUNCEMENT_CONFIRMATION_BUTTON_CANCEL,
} from '../../translations'

import styles from './ConfirmationScreen.scss'

export const ConfirmationScreen = (props) => {
    const { announcementMode, onApply, onCancel, isDisabled } = props

    const isArchive = announcementMode === ANNOUNCEMENT_MODE.ARCHIVE

    const title = isArchive ?
        ANNOUNCEMENT_CONFIRMATION_TITLE_ARCHIVE :
        ANNOUNCEMENT_CONFIRMATION_TITLE_DELETE

    const description = isArchive ?
        ANNOUNCEMENT_CONFIRMATION_DESCRIPTION_ARCHIVE :
        ANNOUNCEMENT_CONFIRMATION_DESCRIPTION_DELETE

    const applyButtonCaption = isArchive ?
        ANNOUNCEMENT_CONFIRMATION_BUTTON_APPLY_ARCHIVE :
        ANNOUNCEMENT_CONFIRMATION_BUTTON_APPLY_DELETE

    return (
        <div className={styles.base}>
            <div>
                <div className={styles.warningIcon} />
                <div className={styles.contentWrapper}>
                    <h1 className={styles.title}>
                        {title}
                    </h1>
                    <div className={styles.description}>
                        {description}
                    </div>
                </div>
                <div className={styles.controls}>
                    <Button
                        isDisabled={isDisabled}
                        onClick={onApply}
                        mixClassName={styles.button}
                    >
                        <span className={styles.buttonText}>
                            {applyButtonCaption}
                        </span>
                    </Button>
                    <Button
                        type={'secondary'}
                        onClick={onCancel}
                        mixClassName={styles.button}
                    >
                        <span className={styles.buttonText}>
                            {ANNOUNCEMENT_CONFIRMATION_BUTTON_CANCEL}
                        </span>
                    </Button>
                </div>
            </div>
        </div>
    )
}

ConfirmationScreen.propTypes = {
    announcementMode: PropTypes.oneOf(Object.values(ANNOUNCEMENT_MODE)).isRequired,
    onApply: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool,
}

ConfirmationScreen.defaultProps = {
    isDisabled: false,
}



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/AnnouncementsCard/components/ConfirmationScreen/ConfirmationScreen.jsx